module.exports = __webpack_public_path__ + "static/media/service-list-desktop@2x.dae6f6a0.jpg";